







































import {Emit} from 'vue-property-decorator';
import {InOut} from 'vue-inout-prop-decorator';
import {Component, Vue} from '@/shared/component';

import {Projet} from '@/models';

import CrudProjetEdit from '@/components/Crud/Projet/Edit.vue';

@Component({
	components: {
		CrudProjetEdit,
	}
})
export default class CrudProjetEditDialog extends Vue {
	@InOut({ type: Projet  , isVModel: true }) private value!: Projet;
	@InOut({ type: Boolean  , isVModel: false }) private route!: Boolean;

	@Emit()
	private onSubmit(projet: Projet) {
		this.onClose();
	}

	@Emit()
	private onClose() {
		if (this.value.id)
		{
			if (this.route == true) {
				if (
					this.$route.name !== 'projet-show' ||
					this.$route.params["id"] !== this.value.id.toString()
				) {
					this.$router.push({name: 'projet-show', params: { id : this.value.id.toString() }});
				}
			}
		}
		this.value = null;
	}
}
